"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.opponent = exports.addUserToPlayers = exports.isUserInGame = exports.isGameFull = void 0;
const Model_1 = require("./Model");
const isGameFull = (players) => players[Model_1.WHITE] !== null && players[Model_1.BLACK] !== null;
exports.isGameFull = isGameFull;
const isUserInGame = (players, user) => players.some((player) => (player === null || player === void 0 ? void 0 : player.email) === user.email);
exports.isUserInGame = isUserInGame;
const addUserToPlayers = (players, user) => {
    if (players[Model_1.WHITE] === null) {
        return [user, players[Model_1.BLACK]];
    }
    if (players[Model_1.BLACK] === null) {
        return [players[Model_1.WHITE], user];
    }
    throw new Error('Game is full');
};
exports.addUserToPlayers = addUserToPlayers;
const opponent = (player) => player === Model_1.WHITE ? Model_1.BLACK : Model_1.WHITE;
exports.opponent = opponent;
